import { render, staticRenderFns } from "./ModalSubirEnlace.vue?vue&type=template&id=489c9064&"
import script from "./ModalSubirEnlace.vue?vue&type=script&lang=js&"
export * from "./ModalSubirEnlace.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubirEnlace.vue?vue&type=style&index=0&id=489c9064&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports